// constants/entities.js
// Liste standardisée des entités utilisée dans toute l'application
export const ENTITIES = [
  'MFG Technologies',
  'GEM',
  'Solio Group',
  'Asking',
  'Croissance Capital',
  'Growth Energy'
];
